import React, { useState } from 'react';
import { FaLayerGroup, FaTimes, FaCopy, FaCheck } from 'react-icons/fa';

const formatWeight = (w) =>
  (w || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const formatNumber = (n) => (n || 0).toLocaleString();

// Sticky running-total bar for the "select rows to sum" feature. Sums the rows
// the user has checked within a single column (one dimension at a time).
const SelectionBar = ({ selection, onClear }) => {
  const [copied, setCopied] = useState(false);

  if (!selection || selection.items.length === 0) return null;

  const totalWeight = selection.items.reduce((s, it) => s + it.weight, 0);
  const totalTickets = selection.items.reduce((s, it) => s + it.tickets, 0);

  const handleCopy = () => {
    const lines = selection.items.map(
      (it) => `${it.value}: ${formatWeight(it.weight)} t (${formatNumber(it.tickets)} tickets)`
    );
    const text =
      `${selection.dimLabel} — selected sum\n` +
      lines.join('\n') +
      `\nTotal: ${formatWeight(totalWeight)} t (${formatNumber(totalTickets)} tickets)`;
    if (navigator.clipboard) {
      navigator.clipboard.writeText(text).then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 1500);
      });
    }
  };

  return (
    <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-40 w-[min(92vw,640px)]">
      <div className="bg-slate-800 text-white dark:text-slate-50 rounded-xl shadow-2xl px-4 py-3 flex items-center gap-4">
        <div className="flex items-center gap-2 text-primary-300 flex-shrink-0">
          <FaLayerGroup />
          <span className="text-sm font-medium hidden sm:inline">{selection.dimLabel}</span>
        </div>

        <div className="flex-1 min-w-0 flex items-baseline gap-x-4 gap-y-0 flex-wrap">
          <span className="text-sm">
            <span className="font-bold text-base">{selection.items.length}</span>
            <span className="text-slate-300"> selected</span>
          </span>
          <span className="text-sm">
            <span className="font-bold text-base text-primary-300 tabular-nums">
              {formatWeight(totalWeight)} t
            </span>
          </span>
          <span className="text-sm text-slate-300 tabular-nums">
            {formatNumber(totalTickets)} tickets
          </span>
        </div>

        <div className="flex items-center gap-2 flex-shrink-0">
          <button
            onClick={handleCopy}
            className="flex items-center gap-1.5 px-2.5 py-1.5 text-xs font-medium bg-slate-700 hover:bg-slate-600 rounded-md transition-colors"
            title="Copy selection to clipboard"
          >
            {copied ? <FaCheck className="text-green-400" /> : <FaCopy />}
            <span className="hidden sm:inline">{copied ? 'Copied' : 'Copy'}</span>
          </button>
          <button
            onClick={onClear}
            className="flex items-center gap-1.5 px-2.5 py-1.5 text-xs font-medium bg-slate-700 hover:bg-slate-600 rounded-md transition-colors"
          >
            <FaTimes />
            <span className="hidden sm:inline">Clear</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default SelectionBar;
